import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogDescription, // Dodajemy DialogDescription dla lepszej struktury
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import {
  HelpCircle,
  Plus,
  Minus,
  Award,
  MessageSquare,
  Zap,
  ShieldCheck,
  ShieldAlert,
  Trophy,
} from "lucide-react"; // Dodajemy ikony
import { cn } from "@/lib/utils"; // Jeśli używasz cn do klas

export default function ScoringRulesDialog() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="gap-2 text-xs sm:text-sm"
        >
          {" "}
          {/* Lepsza responsywność tekstu */}
          <HelpCircle className="w-4 h-4" />
          Zasady Punktacji {/* Zmieniony tekst dla spójności */}
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-md">
        <DialogHeader className="mb-4">
          {" "}
          {/* Dodano mb-4 */}
          <DialogTitle className="flex items-center gap-2 text-xl">
            {" "}
            {/* Zwiększono font */}
            <Award className="w-6 h-6 text-yellow-400" />{" "}
            {/* Powiększono ikonę */}
            Jak działa punktacja?
          </DialogTitle>
          <DialogDescription>
            Punkty są przyznawane lub odejmowane w trybie "Klasycznym" (Prawda
            czy Wyzwanie).
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 overflow-y-auto max-h-[400px]">
          {/* Sekcja Pytania (Prawda) */}
          <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <MessageSquare className="w-5 h-5 text-blue-400" />
              <span className="font-semibold text-lg text-blue-300">
                Pytania (Prawda)
              </span>
            </div>
            <div className="space-y-1.5 text-sm">
              <p className="flex items-center gap-1.5">
                <span className="text-green-300 font-medium">+1 punkt:</span>
                <span className="text-muted-foreground">
                  Za udzielenie odpowiedzi.
                </span>
              </p>
              <p className="flex items-center gap-1.5">
                <span className="text-red-300 font-medium">-1 punkt:</span>
                <span className="text-muted-foreground">
                  Za odmowę odpowiedzi.
                </span>
              </p>
            </div>
          </div>

          {/* Sekcja Wyzwania */}
          <div className="bg-purple-500/10 border border-purple-500/30 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Zap className="w-5 h-5 text-purple-400" />
              <span className="font-semibold text-lg text-purple-300">
                Wyzwania
              </span>
            </div>
            <div className="space-y-1.5 text-sm">
              <p className="flex items-center gap-1.5">
                <span className="text-green-300 font-medium">+3 punkty:</span>
                <span className="text-muted-foreground">
                  Za pomyślne wykonanie.
                </span>
              </p>
              <p className="flex items-center gap-1.5">
                <span className="text-red-300 font-medium">-3 punkty:</span>
                <span className="text-muted-foreground">
                  Za niewykonanie / poddanie się.
                </span>
              </p>
            </div>
          </div>

          {/* Sekcja Pominięcia (bez zmian w logice, lekka zmiana wizualna) */}
          <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <ShieldCheck className="w-5 h-5 text-yellow-400" />{" "}
              {/* Zmieniona ikona */}
              <span className="font-semibold text-lg text-yellow-300">
                Darmowe Pominięcia
              </span>
            </div>
            <p className="text-sm text-muted-foreground">
              Każdy gracz może pominąć maksymalnie 2 zadania (Pytanie lub
              Wyzwanie) bez kary punktowej. Zużywają one "token pominięcia".
            </p>
          </div>

          {/* Sekcja Zwycięzca (bez zmian w logice) */}
          <div className="bg-primary/10 border border-primary/30 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Trophy className="w-5 h-5 text-primary" />{" "}
              {/* Zmieniono ikonę na Trophy dla spójności */}
              <span className="font-semibold text-lg text-primary">
                Zwycięzca
              </span>
            </div>
            <p className="text-sm text-muted-foreground">
              Gracz z największą liczbą punktów na końcu gry wygrywa!
            </p>
          </div>

          <p className="text-xs text-muted-foreground text-center pt-2">
            W trybach "Nigdy Przenigdy" oraz "Wskaż Osobę" punktacja nie jest
            standardowo stosowana – liczy się dobra zabawa i interakcja! (Chyba
            że ustalicie własne zasady domowe).
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
